<template>
    <div>
        <user-menu />
        <div class="wrapper">
            <EnterpriseAdminSidebarMenu 
                :readOnly="isReadOnly"
            />
            <div class="content-wrapper">
                <div class="container-wrapper center">
                    <div>
                        <h3 class="d-inline heading">Locations</h3>
                        <a class="print_icons" href="javascript:void(0)" @click="goToPrint">
                            <i class="fa fa-print"></i>
                        </a>
                    </div>
                    <div class="heading-seperator"></div>
                    <div class="margin-bottom-10"></div>
                    <div class="">
                        <flash-message autoHide variant="success"></flash-message>
                        <b-navbar toggleable="lg" type="light" variant="light">
                            <b-navbar-brand href="#">Filter/Search</b-navbar-brand>
                            <b-navbar-toggle target="nav-collapse"><i class="fa fa-chevron-down	"></i></b-navbar-toggle>
                            <b-collapse id="nav-collapse" is-nav>
                                <div class="search-wrapper col-12">
                                    <div class="row col-12 override-padding">
                                        <div class="search_filter_1">
                                            <b-form-select
                                                class="location-custom-select"
                                                name="status"
                                                id="status"
                                                v-model="search_status"
                                                :options="status"
                                                @change="changeStatus">
                                            </b-form-select>
                                        </div>
                                        <div class="search_filter_2">by</div>
                                        <div :class="(isReadOnly) ? 'search_filter_readonly_3' : 'search_filter_3'">
                                            <b-form-select 
                                                class="location-custom-select" 
                                                v-model="search_group" 
                                                :options="account_groups_options"
                                                @change="changeGroups">
                                            </b-form-select>
                                        </div>
                                        <div class="search_filter_4">
                                            <input
                                                type="text"
                                                name="org name"
                                                id="org_name"
                                                class="search_org_text"
                                                ref="org_name"
                                                v-model="org_name"
                                                maxlength="250"
                                                @keyup.enter="setLocationFilterbyName">
                                            <span class="search-icon" @click="setLocationFilterbyName">
                                                <i class="fa fa-search search_icons"></i>
                                            </span>
                                        </div>
                                        <div class="search_filter_5">
                                            <button type="button" class="float-left btn btn-sm createBtn" @click="openNewGroup">Create New Group</button>
                                        </div>
                                        <div class="search_filter_6" v-if="!isReadOnly">
                                            <button type="button" class="float-left btn btn-sm createBtn" @click="openNewLocation">Add New Location</button>
                                        </div>
                                    </div>
                                </div>
                            </b-collapse>
                        </b-navbar>
                    </div>
                    <div class="margin-bottom-10"></div>
                    <div>
                        <b-card no-body class="manage_locations">
                            <div class="row">
                                <div class="font-weight-bold">{{ getLocationTitle }}({{ locationsCount }})</div>
                            </div>
                            <div class="list_locations">
                                <div class="row">
                                    <div
                                        class="location_header manage_heading_1"
                                        v-on:click="sortMethod('companyName')"
                                        >
                                        Location Name
                                        <i v-if="sortField == 'companyName' && publicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                        <i v-if="sortField == 'companyName' && publicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                                    </div>
                                    <div
                                        class="location_header manage_heading_2"
                                        v-on:click="sortMethod('city')"
                                        >
                                        City
                                        <i v-if="sortField == 'city' && publicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                        <i v-if="sortField == 'city' && publicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                                    </div>
                                    <div
                                        class="location_header manage_heading_3"
                                        v-on:click="sortMethod('stateCode')"
                                        >
                                        State
                                        <i v-if="sortField == 'stateCode' && publicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                        <i v-if="sortField == 'stateCode' && publicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                                    </div>
                                    <div
                                        class="location_header manage_heading_4"
                                        v-on:click="sortMethod('group')"
                                        >
                                        Group
                                        <i v-if="sortField == 'group' && publicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                        <i v-if="sortField == 'group' && publicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                                    </div>
                                    <div
                                        class="location_header manage_heading_5"
                                        v-on:click="sortMethod('first_name')"
                                        >
                                        Manager
                                        <i v-if="sortField == 'first_name' && publicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                        <i v-if="sortField == 'first_name' && publicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                                    </div>
                                    <div
                                        class="location_header manage_heading_6 text-center"
                                        v-on:click="sortMethod('status')"
                                        >
                                        Status
                                        <i v-if="sortField == 'status' && publicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                        <i v-if="sortField == 'status' && publicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                                    </div>
                                    <div
                                        class="location_header manage_heading_7 text-center"
                                        >
                                        Mentees
                                        <i v-if="sortField == 'mentees' && publicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                        <i v-if="sortField == 'mentees' && publicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                                    </div>
                                    <div
                                        class="location_header manage_heading_8 text-center"
                                        >
                                        Apprentices
                                        <i v-if="sortField == 'apprentices' && publicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                        <i v-if="sortField == 'apprentices' && publicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                                    </div>
                                </div>
                                <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
                                <div v-if="locations.length > 0" class="row_items">
                                    <div class="row_data_border" v-for="(item, index) in locations" :key="index">
                                        <div class="location_item_1"><a @click="openSidebar(item.accId)" class="ea-quick-link"> {{ item.accountName }}</a></div>
                                        <div class="location_item_2">{{ (item.city) ? item.city : "&nbsp;" }}</div>
                                        <div class="location_item_3">{{ (item.stateName) ? item.stateName : "&nbsp;" }}</div>
                                        <div class="location_item_4">
                                            <a @click="openExistingGroupSidebar(item.accountGroupId, item.groupName)" class="ea-quick-link" v-if="item.groupName">{{ item.groupName }}</a>
                                            <span v-else>&nbsp;</span>
                                        </div>
                                        <div class="location_item_5">{{ item.firstName + ' ' + item.lastName }}</div>
                                        <div class="location_item_6 text-center">{{ item.status }}</div>
                                        <div class="location_item_7 text-center">{{ item.menteesCount }}</div>
                                        <div class="location_item_8 text-center">{{ item.apprenticesCount }}</div>
                                        <div class="clearfix"></div>
                                    </div>
                                </div>
                                <div class="text-red text-center m-4">{{ getNoRecordText(locationsCount) }}</div>
                            </div>
                        </b-card>
                    </div>
                    <div class="margin-bottom-10"></div>
                    <div v-if="search_group">
                        <b-card no-body class="manage_locations">
                            <div class="row">
                                <div class="font-weight-bold">{{ getGroupedTitle }}({{ grouped_locationsCount }})</div>
                            </div>
                            <div class="list_locations">
                                <div class="row">
                                    <div
                                        class="location_header manage_heading_1"
                                        v-on:click="sortMethod('companyName', 'grouped')"
                                        >
                                        Location Name
                                        <i v-if="groupSortField == 'companyName' && groupPublicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                        <i v-if="groupSortField == 'companyName' && groupPublicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                                    </div>
                                    <div
                                        class="location_header manage_heading_2"
                                        v-on:click="sortMethod('city', 'grouped')"
                                        >
                                        City
                                        <i v-if="groupSortField == 'city' && groupPublicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                        <i v-if="groupSortField == 'city' && groupPublicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                                    </div>
                                    <div
                                        class="location_header manage_heading_3"
                                        v-on:click="sortMethod('stateCode', 'grouped')"
                                        >
                                        State
                                        <i v-if="groupSortField == 'stateCode' && groupPublicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                        <i v-if="groupSortField == 'stateCode' && groupPublicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                                    </div>
                                    <div
                                        class="location_header manage_heading_4"
                                        v-on:click="sortMethod('group', 'grouped')"
                                        >
                                        Group
                                        <i v-if="groupSortField == 'group' && groupPublicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                        <i v-if="groupSortField == 'group' && groupPublicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                                    </div>
                                    <div
                                        class="location_header manage_heading_5"
                                        v-on:click="sortMethod('first_name', 'grouped')"
                                        >
                                        Manager
                                        <i v-if="groupSortField == 'first_name' && groupPublicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                        <i v-if="groupSortField == 'first_name' && groupPublicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                                    </div>
                                    <div
                                        class="location_header manage_heading_6 text-center"
                                        v-on:click="sortMethod('status', 'grouped')"
                                        >
                                        Status
                                        <i v-if="groupSortField == 'status' && groupPublicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                        <i v-if="groupSortField == 'status' && groupPublicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                                    </div>
                                    <div
                                        class="location_header manage_heading_7 text-center"
                                        >
                                        Mentees
                                        <i v-if="groupSortField == 'mentees' && groupPublicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                        <i v-if="groupSortField == 'mentees' && groupPublicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                                    </div>
                                    <div
                                        class="location_header manage_heading_8 text-center"
                                        >
                                        Apprentices
                                        <i v-if="groupSortField == 'apprentices' && groupPublicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                        <i v-if="groupSortField == 'apprentices' && groupPublicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                                    </div>
                                    <div
                                        class="location_header manage_heading_9 text-center"
                                        v-on:click="sortMethod('name', 'grouped')"
                                        >
                                        License
                                        <i v-if="groupSortField == 'name' && groupPublicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                        <i v-if="groupSortField == 'name' && groupPublicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                                    </div>
                                    <div
                                        class="location_header manage_heading_10"
                                        v-on:click="sortMethod('validityDuration', 'grouped')"
                                        >
                                        Expires
                                        <i v-if="groupSortField == 'validityDuration' && groupPublicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                        <i v-if="groupSortField == 'validityDuration' && groupPublicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                                    </div>
                                </div>
                                <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
                                <div v-if="grouped_locations.length > 0" class="row_items">
                                    <div class="row_data_border" v-for="(item, index) in grouped_locations" :key="index">
                                        <div class="location_item_1"><a @click="openSidebar(item.accId)" class="ea-quick-link"> {{ item.accountName }}</a></div>
                                        <div class="location_item_2">{{ (item.city) ? item.city : "&nbsp;" }}</div>
                                        <div class="location_item_3">{{ (item.stateName) ? item.stateName : "&nbsp;" }}</div>
                                        <div class="location_item_4">
                                            <a @click="openExistingGroupSidebar(item.accountGroupId, item.groupName)" class="ea-quick-link" v-if="item.groupName">{{ item.groupName }}</a>
                                            <span v-else>&nbsp;</span>
                                        </div>
                                        <div class="location_item_5"><i class="fa fa-envelope-o overview-icons"></i> &nbsp; {{ item.firstName + ' ' + item.lastName }}</div>
                                        <div class="location_item_6 text-center">{{ item.status }}</div>
                                        <div class="location_item_7 text-center">{{ item.menteesCount }}</div>
                                        <div class="location_item_8 text-center">{{ item.apprenticesCount }}</div>
                                        <div class="location_item_9 text-center">
                                            <span v-if="item.subscriptionName" class="license_text">{{ item.subscriptionName }}</span>
                                            <span v-else>n/a</span>
                                        </div>
                                        <div class="location_item_10">
                                            <span v-if="item.expirationDate" class="expired_text">{{ item.expirationDate | formatOrderExpirationDate }}</span>
                                            <span v-else>n/a</span>
                                        </div>
                                        <div class="clearfix"></div>
                                    </div>
                                </div>
                                <div class="text-red text-center m-4">{{ getNoRecordText(grouped_locationsCount) }}</div>
                            </div>
                        </b-card>
                    </div>
                </div>
            </div>
        </div>

        <EnterpriseAdminOverlaySidebar
              :isModalVisible="isModalVisible" 
              @close="closeSidebar"
              ref="location_sidebar" 
              :readOnly="isReadOnly" 
             />

        <AddNewLocation v-if="!isReadOnly"
              :isModalLocationVisible="isModalLocationVisible" 
              :accountId="accountId"
              @close="closeLocationSidebar"
              ref="add_new_location" 
             />

        <AddNewGroup
            :isModalGroupVisible="isModalGroupVisible" 
            :accountId="accountId"
            @close="closeGroupSidebar"
            ref="add_new_group" 
        />

        <ExistingGroup
            :isModalExistingGroupVisible="isModalExistingGroupVisible" 
            :accountId="accountId"
            @close="closeExistingGroupSidebar"
            ref="existing_group_panel" 
        />

    </div>
</template>
<script>
import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import axios from 'axios';
import EnterpriseAdminSidebarMenu from '../shared/enterpriseadmin_sidebar_menu.vue';
import EnterpriseAdminOverlaySidebar from './enterpriseadmin_overlay_sidebar.vue';
import AddNewLocation from './add_new_location.vue';
import AddNewGroup from './add_new_group.vue';
import ExistingGroup from './existing_group.vue';
import router from '../../router/index.js';
import { store } from '../../store/store';
import moment from 'moment';

Vue.filter('formatOrderExpirationDate', function(value) {
    if (value) {
        return moment(String(value)).format('MM/DD/YYYY')
    } else {
        return 'n/a';
    }
});

export default {
    data() {
        return {
            loading: false,
            isModalVisible: false,
            isModalLocationVisible: false,
            isModalGroupVisible: false,
            publicSortBy: '',
            sortField: '',
            locationsCount: 0,
            locations: [],
            accountItems: [],
            search_status: '',
            status: [
                {text: 'All', value: ''},
                {text: 'Active', value: 'active'},
                {text: 'Inactive', value: 'Inactive'},
            ],
            account_groups_options: [],
            search_group: '',
            org_name: '',
            accountId: '',
            defaultTitle: 'All Locations',
            isModalExistingGroupVisible: false,
            grouped_locationsCount: 0,
            grouped_locations: [],
            groupPublicSortBy: '',
            groupSortField: '',
            search_status_name: '',
            search_group_name: ''
        }
    },
    components: {
        UserMenu,
        EnterpriseAdminSidebarMenu,
        EnterpriseAdminOverlaySidebar,
        AddNewLocation,
        AddNewGroup,
        ExistingGroup,
    },
    computed: {
        isReadOnly(){
            if (this.$store.state.enterprise_type === 'Readonly') {
                return true;
            } else {
                if (this.$store.state.switch_admin_enterprise_isreadonly) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        getGroupedTitle() {
            if (this.search_group_name) {
                return this.search_group_name = this.search_group_name;
            }
        },
        getLocationTitle() {
            if (this.search_status_name) {
                return this.search_status_name = this.search_status_name;
            } else {
                return this.defaultTitle;
            }
        }
    },
    methods: {
        sortMethod(field, isGrouped='') {
            if (isGrouped == 'grouped') {
                this.groupSortField = field;
                if(this.groupPublicSortBy == 'ASC') {
                    this.groupPublicSortBy = 'DESC';
                }
                else {
                    this.groupPublicSortBy = 'ASC';
                }
            } else {
                this.sortField = field;
                if(this.publicSortBy == 'ASC') {
                    this.publicSortBy = 'DESC';
                }
                else {
                    this.publicSortBy = 'ASC';
                }
            }
            this.fetchLocationsListitems();
        },
        showLocationsPaginated() {
            this.fetchLocationsListitems();
            this.filterFlag = false;
        },
        changeStatus() {
            if (this.search_status) {
                var name = this.search_status.charAt(0).toUpperCase() + this.search_status.slice(1);
                this.search_status_name = name + ' Locations';
            } else {
                this.search_status_name = this.defaultTitle;
            }
            this.fetchLocationsListitems();    
        },
        changeGroups() {
            if (this.search_group) {
                var name = this.showText(this.search_group);
                this.search_group_name = name + ' Locations';
            }
            this.fetchLocationsListitems();    
        },
        setLocationFilterbyName() {
            this.fetchLocationsListitems();    
        },
        fetchLocationsListitems() {
            this.loading = true;
            this.grouped_locationsCount = 0;
            this.grouped_locations = [];
            if(this.filterFlag) {
                this.currentPage = 1;
            }
            const params = { page: this.currentPage }
            if (this.sortField) {
                params.sortfield = this.sortField
            }
            if (this.publicSortBy) {
                params.sortby = this.publicSortBy
            }
            if (this.groupSortField) {
                params.groupSortField = this.groupSortField
            }
            if (this.groupPublicSortBy) {
                params.groupSortBy = this.groupPublicSortBy
            }
            params.search_status = this.search_status;
            params.search_group = this.search_group;
            params.org_name = this.org_name;
            params.search_status_name = this.search_status_name;
            params.search_group_name = this.search_group_name;
            this.$store.dispatch('search_enterprise_locations', params);
            axios('/enterprise-admin/manage-linked-locations',
            {
                method: 'POST',
                data: {
                    'search_parameters': params
                }
            })
            .then(response => {
                this.loading = false;
                this.locationsCount = response.data.ungrouped.length;
                this.locations = response.data.ungrouped;
                this.grouped_locationsCount = response.data.grouped.length;
                this.grouped_locations = response.data.grouped;
            })
            .catch(() => {
            });
        },
        openSidebar(accountId) {
            this.isModalVisible = true;
            this.$refs.location_sidebar.getLocationDetail(accountId);
        },
        closeSidebar() {
            this.isModalVisible = false;
            this.$refs.location_sidebar.selectedComponent = 'OverviewTab';
        },
        openNewLocation() {
            this.isModalLocationVisible = true;
            this.accountId = this.accountId;
            this.$refs.add_new_location.loadInitialData();
        },
        closeLocationSidebar() {
            this.isModalLocationVisible = false;
        },
        openNewGroup() {
            this.isModalGroupVisible = true;
            this.accountId = this.accountId;
        },
        closeGroupSidebar() {
            this.isModalGroupVisible = false;
        },
        getEnterpriseGroups() {
            if (this.accountId > 0) {
                axios('/enterprise-admin/groups/' + this.accountId,
                {
                    method: 'GET',
                })
                .then(response => {
                    var groupsCount = response.data.groups.length;
                    this.account_groups_options.push({ text:'All', value: '' });
                    for (var m = 0; m < groupsCount; m++) {
                        this.account_groups_options.push({ 
                            text: response.data.groups[m].text, 
                            value: response.data.groups[m].value 
                        });
                    }
                })
                .catch(() => {
                });
            }
        },
        getNoRecordText(count) {
            if (this.loading) {
                return '';
            } else {
                if (count == 0 && this.accountId) {
                    return 'No Location Found';
                }
            }
        },
        showText(val) {
            for (var i = 0; i < this.account_groups_options.length; i++) {
                if (this.account_groups_options[i].value != "" && this.account_groups_options[i].value === val){
                    this.selectedText = this.account_groups_options[i].text;
                    return this.selectedText.charAt(0).toUpperCase() + this.selectedText.slice(1);
                }
            }
            return '';
        },
        openExistingGroupSidebar(groupId, groupName) {
            this.isModalExistingGroupVisible = true;
            this.accountId = this.accountId;
            this.$refs.existing_group_panel.getGroupData(groupId, groupName);
        },
        closeExistingGroupSidebar() {
            this.isModalExistingGroupVisible = false;
        },
        goToPrint(){
            router.push('/print-enterprise-locations')
        }
    },
    created() {
        store.dispatch('clear_search_enterprise_locations');
        axios('/enterprise-admin-info',
        {
            method: 'GET',
        })
        .then(resp => {
            this.accountItems = resp.data.account;
            this.accountId = this.accountItems.id;
            this.locationListTitle = this.defaultTitle;
            this.fetchLocationsListitems();
            this.getEnterpriseGroups();
            if (this.$route.params.accountId) {
                this.openSidebar(this.$route.params.accountId)
            }
            
        })
        .catch(() => {
        });
        
    },
}
</script>
<style scoped>
.manage_locations { padding: 2rem; background-color: #FFF !important; }
.list_locations { padding: 0 1rem; margin: 1rem 0; }
.location_header { float: left; font-weight: 900; margin-top: 15px; }
.manage_heading_1 { width: 28%; cursor: pointer; }
.manage_heading_2 { width: 10%; cursor: pointer; }
.manage_heading_3 { width: 6%; cursor: pointer; }
.manage_heading_4 { width: 12%; cursor: pointer; }
.manage_heading_5 { width: 18%; cursor: pointer; }
.manage_heading_6 { width: 8%; cursor: pointer; }
.manage_heading_7 { width: 8%; }
.manage_heading_8 { width: 10%; }
.manage_heading_9 { width: 10%; cursor: pointer; }
.manage_heading_10 { width: 10%; cursor: pointer; }
.location_item_1 { width: 28%; float: left; }
.location_item_2 { width: 10%; float: left; }
.location_item_3 { width: 6%; float: left; }
.location_item_4 { width: 12%; float: left; }
.location_item_5 { width: 18%; float: left; }
.location_item_6 { width: 8%; float: left; }
.location_item_7 { width: 8%; float: left; }
.location_item_8 { width: 10%; float: left; }
.location_item_9 { width: 10%; float: left; }
.location_item_10 { width: 10%; float: left; }
.row_items { margin-right: -15px; margin-left: -15px }
.row_data_border { padding: 5px 0; margin: 10px 0; font-size: 14px;border-bottom: 1px solid rgba(0, 0, 0, 0.1); }
.row_data_border:nth-last-child(1) { border-bottom: 0 none; }
.text-green { color: #28a745 !important; font-weight: 900; }
.text-red { color: #dc3545 !important; font-weight: 900; }
.ea-group-name, .ea-quick-link {
  text-decoration: underline !important;
  cursor: pointer;
}
.heading { padding-left: 0px; }
.overview-icons { color: #bfbfbf; font-size: 1rem; }
.print_icons { font-size: 1.5rem;float: right; margin: 1px 0; color: #000 !important; }
.search_icons { font-size: 1.5rem; color: #bfbfbf; }
.location-custom-select { width: 150px; height: 32px; border-radius: 10px; }
.search_org_text { width: 120px;outline: 0; border-width: 0 0 2px; border-color: #bfbfbf; background-color: #e9e9e9; }
.license_text { text-decoration: underline; color: #00acee; }
.search_filter_1 { width: 20%; }
.search_filter_2 { width: 3%; margin-top: 7px; }
.search_filter_3 { width: 30%; }
.search_filter_4 { width: 17%; }
.search_filter_5 { width: 15%; }
.search_filter_6 { width: 15%; }
.search_filter_readonly_3 { width: 45%; }
.createBtn, .createBtn:focus, .createBtn:active, .createBtn:hover {
  color: #00acee !important; 
  background-color: #FFF !important;
  border: 1px solid #00acee !important;
  font-weight: 900;
  width: 150px;
  border-radius: 10px;
}
.expired_text { color: green; }
.loading_show { height: auto; }
</style>



// WEBPACK FOOTER //
// src/components/enterpriseadmin/enterprise_locations.vue